import { Button, Grid, Menu, Layout, Paper, Table, ButtonGroup, Loader } from "../../components";
import moment from "moment";
import { CARD_BRAND_OPTIONS } from "../../constants";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useAxios } from '../../hooks'

export function Cards () {
    const [cards] = useAxios(`/card`)

    return (
        <Layout>
            <Grid container justifyContent="center" minHeight={"calc(100vh - 64px)"} padding={3} >
                {cards.loading ? (
                    <div style={{
                        display: 'flex',
                        flex: '1',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Loader />
                    </div>
                ) :(<Grid item xs={12} sm={10}>
                    <Grid container paddingBottom={2} justifyContent="flex-start">
                        <Grid item xs={4} justifyContent="flex-start">
                            <Button href="/cartoes/novo">
                                Novo Cartão
                            </Button>
                        </Grid>
                    </Grid>
                    <Paper elevation={1}>
                    <Table 
                        columns={[
                            { field: 'id', headerName: 'ID', width: 50 },
                            { field: 'created_at', headerName: 'Data', width: 200, valueFormatter: ({value}) => {
                                return moment(value).format('DD/MM/YYYY HH:mm:ss')
                            } },
                            { field: 'bank', headerName: 'Banco', flex: 1 },
                            { field: 'brand', headerName: 'Bandeira', flex: 1 },
                            { field: 'last_four_digits', headerName: 'Número', flex: 1, valueFormatter: ({value}) => {
                                return `**** **** **** ${value}`
                            }},
                            {
                                field: 'actions', headerName: '', sortable: false, filterable: false, disableColumnMenu: true, renderCell: ({row}) => {
                                    return (
                                        <ButtonGroup>
                                            <Menu
                                                options={[
                                                    { 
                                                        label: 'Excluir Cartão', 
                                                        onClick: async () => {
                                                            // await api.delete(`/bid/${row.id}`)
                                                            // bids.mutate()
                                                        }
                                                    },
                                                ]}
                                            >
                                                <MoreHorizIcon />
                                            </Menu>
                                        </ButtonGroup>
                                    )
                                }
                            }
                        ]}
                        rows={cards?.data?.map((item: any) => ({
                            id: item.id,
                            created_at: item.created_at,
                            bank: item.bank,
                            brand: CARD_BRAND_OPTIONS.find(brand => brand.value === item.brand)?.label,
                            last_four_digits: item.last_four_digits,
                        })) || []}
                    />
                    </Paper>
                </Grid>)}
            </Grid>
        </Layout>
    )
}